import NativeMeshInteractor from "./NativeMeshInteractor";

export default {
    accessToken: "",
    async setAccessToken() {
        this.accessToken = await NativeMeshInteractor.getAccessToken();
    }
};